module.exports = __webpack_public_path__ + "static/media/localhost.f7b99905.webp";